import { Box, Typography, styled } from "@mui/material";
import HeartImage from "../../../assets/landingpage/heart.png";

const HeartLogo = styled("img")(() => ({
  width: 50,
  margin: "0 10px",
}));

const Heartbanner = () => {
  return (
    <Box sx={{ background: (theme) => theme.palette.primary.main }} data-testid="heartbanner">
      <Typography
        variant="h6"
        component="h6"
        sx={{
          py: 1,
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        Unser <HeartLogo src={HeartImage} alt="Herz" /> schlägt für Bildung
      </Typography>
    </Box>
  );
};

export default Heartbanner;
